import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { StreamReport } from 'src/app/models/stream-report';
import { VideoService } from 'src/app/services/video.service';
import { UiService } from '../../services/ui.service';
import { Utils } from '../../services/util.service';
import { LiveService } from '../../services/live.service';

declare var videojs: any;

@Component({
    selector: 'videojs-live',
    templateUrl: './videojs-live.component.html',
    styleUrls: ['./videojs-live.component.css']
})
export class VideojsLiveComponent implements OnInit, AfterViewInit, OnDestroy {

    @Input() url: string;
    @Input() livestreamId: number;

    player: any;
    lastReportedTime = 0;
    frequency = 60;
    isSafari: boolean = false;
    watchDuration: number = 0;

    sessionGuid: string;

    constructor(private ui: UiService,
                private videoService: VideoService,
                private liveService: LiveService) {
    }

    ngOnInit(): void {
        this.ui.stopLoading();
    }

    ngOnDestroy() {
        this.player.pause();
        this.player.dispose();
    }

    ngAfterViewInit() {

        videojs.options.hls.overrideNative = this.isSafari;

        let vjs = 'video';

        this.player = videojs(vjs, { techOrder: ['html5'] });

        let volume = localStorage.getItem('volume');
        if (volume) {
            this.player.volume(volume);
        }

        this.player.hotkeys({
            volumeStep: 0.1,
            enableVolumeScroll: false,
            alwaysCaptureHotkeys: false
        });

        this.sessionGuid = Utils.generateGUID();
        this.reportWatchTime(false);

        this.player.on('error', () => {
            console.log('error');
        });

        this.player.on('ended', () => {
            try {
                videojs(this.player).dispose();
            } catch {
            }
        });

        this.player.on('volumechange', () => {
            localStorage.setItem('volume', this.player.volume());
        });

        this.player.on('timeupdate', () => {
            let time = this.player.currentTime();
            let intTime = (time | 0);
            if (time > 0 && intTime % this.frequency == 0 && intTime > this.lastReportedTime) {

                this.lastReportedTime = intTime;
                this.watchDuration += intTime - this.lastReportedTime;

                this.reportWatchTime();
            }
        });

        this.player.src({
            src: this.url,
            type: 'application/x-mpegURL',
            withCredentials: false,
            overrideNative: this.isSafari,
            cacheEncryptionKeys: true
        });
    }

    reportWatchTime(reportTime = true) {
        this.liveService.reportWatchtime(this.sessionGuid, this.livestreamId, reportTime ? Math.floor((this.watchDuration) * 1000) : undefined).subscribe();
    }
}
